








import { ICruise } from "@/@types/cruiseOffers/cruiseList";
import { getBirthday } from "@/services/dateTime/date-time-fofmat";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class GuestSortCruise extends Vue {
  @Prop({ type: Array, default: () => [] }) cruises!: Array<ICruise>;
  @Prop({ type: String, default: "" }) code!: string;

  get cruise(): string {
    const cruise = this.cruises.find((c) => String(c.id) == String(this.code));
    return cruise ? this.$getLocale(cruise.name) : this.code;
  }

  get dete(): string {
    const cruise = this.cruises.find((c) => String(c.id) == String(this.code));
    return cruise
      ? `${getBirthday(cruise.start_date)}-${getBirthday(cruise.end_date)}`
      : "";
  }
}
